<template>
    <div class="admin-page">
        <!-- Main content -->
        <div class="main-cnt">
            <div class="content-white">
                <div class="content-header ex-input-heading">
                    <form class="form-group" @submit.prevent="searchGroup">
                        <div class="row">
                            <div class="col-3">
                                <div class="form-input ex-w-50">
                                    <label class="form-input-lb" for="searchBranchId">
                                        {{ $t('branch.general.name') }}
                                    </label>
                                    <div class="form-input-cnt">
                                        <select2
                                            id="searchBranchId"
                                            v-model="search.branchId"
                                            class="" name="branchId"
                                            :options="branchSelectOptions"
                                            :settings="branchSelectSettings"
                                            @change="branchSelectChangeEvent($event)"
                                            @select="branchSelectEvent($event)"></select2>
                                    </div>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="form-input ex-w-34">
                                    <label class="form-input-lb" for="searchDepartmentId">
                                        {{ $t('department.general.name') }}
                                    </label>
                                    <div class="form-input-cnt">
                                        <select2
                                            id="searchDepartmentId"
                                            v-model="search.departmentId"
                                            class="" name="departmentId"
                                            :options="departmentSelectOptions"
                                            :settings="departmentSelectSettings"
                                            @change="departmentSelectChangeEvent($event)"
                                            @select="departmentSelectEvent($event)"></select2>
                                    </div>
                                </div>
                            </div>

                            <div class="col-4">
                                <div class="form-input ex-w-84" for="searchGroupId">
                                    <label class="form-input-lb">
                                        {{ $t('group.general.short_name') }}
                                    </label>
                                    <div class="form-input-cnt">
                                        <select2
                                            id="searchGroupId"
                                            v-model="search.groupId"
                                            class="" name="groupId"
                                            :options="groupSelectOptions"
                                            :settings="groupSelectSettings"
                                            @change="groupSelectChangeEvent($event)"
                                            @select="groupSelectEvent($event)"></select2>
                                    </div>
                                </div>
                            </div>

                            <div class="col-2">
                                <button class="btn btn-search-cir" type="submit" :disabled="submitted">
                                    <i class="icon-search-w"></i>
                                </button>
                            </div>

                            <div class="col-6"></div>

                            <div class="col-4" v-if="utils.isSystemAdmin()">
                                <div class="form-input ex-w-84" for="searchCompanyId">
                                    <label class="form-input-lb">
                                        {{ $t('company.general.full_name') }}
                                    </label>
                                    <div class="form-input-cnt">
                                        <select2
                                            id="searchCompanyId"
                                            v-model="search.companyId"
                                            class="" name="companyId"
                                            :options="companySelectOptions"
                                            :settings="companySelectSettings"
                                            @change="companySelectChangeEvent($event)"
                                            @select="companySelectEvent($event)">
                                        </select2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="content-body">
                    <div class="box-content">
                        <div class="row h-100">
                            <div class="col-12 h-100">
                                <div class="d-flex">

                                    <!-- Add -->
                                    <button class="btn btn-pink-53 w160 mr-3" data-toggle="modal" data-target="#addGroup">
                                        <i class="icon-plus-w mr-2"></i>
                                        {{ $t('button.add') }}
                                    </button>

                                    <!-- Edit -->
                                    <button v-if="(editObj.ids.length > 0)" class="btn btn-pink-53 w140 mr-3" data-toggle="modal" data-target="#editGroup" data-vv-scope='s1'>
                                        <i class="icon-pencil-w mr-2"></i>
                                        {{ $t('button.edit') }}
                                    </button>

                                    <button v-else class="btn btn-gray-53 w140 mr-3">
                                        <i class="icon-pencil-w mr-2"></i>
                                        {{ $t('button.edit') }}
                                    </button>

                                    <!-- Delete -->
                                    <button v-if="(deleteObj.ids.length > 0)" class="btn btn-pink-53 w140 mr-3" data-toggle="modal" data-target="#deleteGroup" data-vv-scope='s2'>
                                        <i class="icon-trash mr-2"></i>
                                        {{ $t('button.delete') }}
                                    </button>

                                    <button v-else class="btn btn-gray-53 w140 mr-3">
                                        <i class="icon-trash mr-2"></i>
                                        {{ $t('button.delete') }}
                                    </button>
                                </div>

                                <div class="block-cnt">

                                    <div class="loading" v-if="(loading == true)" data-vv-scope='s3'></div>

                                    <div class="table-list" v-if="(listsGroup != null) && (loading == false)" data-vv-scope='s4'>
                                        <table class="table">
                                            <tr>
                                                <th>
                                                    <label class="checkbox-custom">
                                                        <input type="checkbox" name="selectAllGroup" v-on:change="selectAllGroup($event)" ref="selectAllGroup">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </th>
                                                <th>{{ $t('branch.general.code') }}</th>
                                                <th>{{ $t('branch.general.full_name') }}</th>
                                                <th>{{ $t('company.general.full_name') }}</th>
                                                <th>{{ $t('department.general.code') }}</th>
                                                <th>{{ $t('department.general.full_name') }}</th>
                                                <th>{{ $t('group.general.code') }}</th>
                                                <th>{{ $t('group.general.full_name') }}</th>
                                            </tr>

                                            <tr v-for="item in listsGroup" :key="item.id">
                                                <td>
                                                    <label class="checkbox-custom">
                                                        <input type="checkbox" name="selectGroup[]" v-on:change="selectGroup($event)" :value="item.id" ref="selectGroup">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td>{{ item.branch_code }}</td>
                                                <td>{{ item.branch_name }}</td>
                                                <td>{{ item.company_name }}</td>
                                                <td>{{ item.department_code }}</td>
                                                <td>{{ item.department_name }}</td>
                                                <td>{{ item.code }}</td>
                                                <td>{{ item.name }}</td>
                                            </tr>
                                        </table>
                                    </div>

                                    <div class="clearfix"></div>

                                    <div class="page-block" v-if="lastPage > 1" data-vv-scope='s5'>
                                        <paginate
                                            v-model="page"
                                            :page-count="lastPage"
                                            :page-range="3"
                                            :margin-pages="1"
                                            :click-handler="requestPagination"
                                            :prev-text="$t('pagination.prev')"
                                            :next-text="$t('pagination.next')"
                                            :class="''"
                                            :container-class="'pagination'"
                                            :page-class="'page-item'"
                                            :prev-class="'page-item'"
                                            :next-class="'page-item'"
                                            :page-link-class="'page-link'"
                                            :prev-link-class="'page-link'"
                                            :next-link-class="'page-link'">
                                        </paginate>
                                    </div>

                                    <div class="clearfix"></div>

                                    <div class="no-data" v-if="(listsGroup == null) && (loading == false)" data-vv-scope='s6'>
                                        {{ $t('general.no_data') }}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <add-group-management
            @updateListGroup="fetchData"
            @updateAllBranchs="getAllBranchs"
            @updateAllDepartments="getAllDepartments"
            @updateAllGroups="getAllGroups"
            @unSlectAllGroup="unSlectAllGroup">
        </add-group-management>

        <edit-group-management
            :editObj='editObj'
            :groupObj='groupObj'
            @updateListGroup="fetchData"
            @updateAllBranchs="getAllBranchs"
            @updateAllDepartments="getAllDepartments"
            @updateAllGroups="getAllGroups"
            @unSlectAllGroup="unSlectAllGroup">
        </edit-group-management>

        <delete-group-management
            :deleteObj='deleteObj'
            :groupObj='groupObj'
            @updateListGroup="fetchData"
            @updateAllBranchs="getAllBranchs"
            @updateAllDepartments="getAllDepartments"
            @updateAllGroups="getAllGroups"
            @unSlectAllGroup="unSlectAllGroup">
        </delete-group-management>

    </div>
</template>

<script>
/* global $ */
import _ from 'lodash';
import AddGroupManagement from './Add';
import EditGroupManagement from './Edit';
import DeleteGroupManagement from './Delete';

import GroupManagementService from '@/services/admin/group.service';
import StorageService from '@/services/common/storage.service';
import { AuthService } from '@/services/common/auth.service';

import Utils from '@/helpers/utils';

import { Constants } from "@/helpers/constants";

export default {
    components: {
        AddGroupManagement,
        EditGroupManagement,
        DeleteGroupManagement,
    },
    name: 'ListGroupManagement',
    data () {
        return {
            search: {
                branchId: "",
                departmentId: "",
                groupId: "",
                companyId: "",
            },
            editObj: {
                ids: [],
            },
            deleteObj: {
                ids: [],
            },

            branchs: [],
            branchSelectOptions: [],
            branchSelectSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.branch'),
                data: this.branchSelectOptions,
            },

            departments: [],
            departmentSelectOptions: [],
            departmentSelectSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.department'),
                data: this.departmentSelectOptions,
            },

            groups: [],
            groupSelectOptions: [],
            groupSelectSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.group'),
                data: this.groupSelectOptions,
            },

            companies: [],
            companySelectOptions: [],
            companySelectSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.company'),
                data: this.companySelectOptions,
            },

            loading: false,
            submitted: false,
            page: 1,
            lastPage: 0,
            lists: null,

            groupObj: {
                id: "",
                companyId: "",
                branchId: "",
                branchCode: "",
                branchName: "",
                departmentId: "",
                departmentCode: "",
                departmentName: "",
                groupCode: "",
                groupName: "",
                type: "",
            },
            utils: Utils,
        };
    },
    beforeCreate () {
    },
    created () {
        this.fetchData();
        this.getAllDepartments();
        this.getAllBranchs();
        this.getAllGroups();
        this.getAllCompanies();
    },
    beforeMount () {
    },
    mounted () {
    },
    computed: {
        listsGroup: function () {
            this.$forceUpdate();
            if (this.lists && this.lists.length > 0) {
                let _list = [];
                $.each(this.lists, function (key, value) {
                    let item = {
                        id: value.id,
                        name: !Utils.isEmptyStr(value.name) ? value.name : "-",
                        code: !Utils.isEmptyStr(value.code) ? value.code : "-",
                        department_id: !Utils.isEmptyStr(value.department_id) ? value.department_id : "-",
                        department_code: !Utils.isEmptyStr(value.department_code) ? value.department_code : "-",
                        department_name: !Utils.isEmptyStr(value.department_name) ? value.department_name : "-",
                        branch_id: !Utils.isEmptyStr(value.branch_id) ? value.branch_id : "-",
                        unit_name: !Utils.isEmptyStr(value.unit_name) ? value.unit_name : "-",
                        branch_code: !Utils.isEmptyStr(value.branch_code) ? value.branch_code : "-",
                        branch_name: !Utils.isEmptyStr(value.branch_name) ? value.branch_name : "-",
                        company_name: !Utils.isEmptyStr(value.company_name) ? value.company_name : "-",
                        type: !Utils.isEmptyStr(value.type) ? value.type : "-",
                    };
                    _list.push(item);
                });
                return _list;
            } else {
                return null;
            }
        },
    },
    watch: {
        '$route' () {
            this.fetchData();
            this.getAllDepartments();
            this.getAllBranchs();
            this.getAllGroups();
            this.getAllCompanies();
        },
    },
    methods: {
        fetchData: function fetchData () {
            this.$forceUpdate();
            this.loading = true;
            this.submitted = true;

            let _page = this.$route.query.page;
            if (Utils.isEmptyStr(_page)) {
                _page = this.page;
            }

            GroupManagementService.listGroup(this.search, _page)
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data.rows.length > 0) {
                        this.lists = response.data.rows;
                        this.lastPage = response.data.last_page;
                        this.page = response.data.current_page;
                    } else {
                        this.lists = null;
                        this.lastPage = 0;
                        this.page = 1;
                    }
                    this.loading = false;
                    this.submitted = false;
                }).catch(error => {
                    this.loading = false;
                    this.submitted = false;
                });

            return false;
        },

        searchGroup: function searchGroup (event) {
            event.preventDefault();
            this.resetData();
            this.fetchData();
            return false;
        },

        selectGroup: function selectGroup (event) {
            event.preventDefault();
            let _ids = [];

            $.each(this.$refs.selectGroup, function (key, elm) {
                if (elm.checked) {
                    _ids.push(elm.value);
                }
            });

            this.deleteObj.ids = _ids;
            this.editObj.ids = _ids;

            if (_ids.length <= 0) {
                if (!Utils.isEmptyStr(this.$refs.selectAllGroup)) {
                    this.$refs.selectAllGroup.checked = false;
                }
            }

            if ((this.lists) && (_ids.length == this.lists.length)) {
                if (!Utils.isEmptyStr(this.$refs.selectAllGroup)) {
                    this.$refs.selectAllGroup.checked = true;
                }
            }

            if (_ids.length == 1) {
                let id = _ids[0];
                // let _this = this;

                let _groupObjSelect = _.filter(this.lists, function (n) {
                    return n.id == id;
                });

                if (!Utils.isEmptyArr(_groupObjSelect)) {
                    this.groupObj.id = _groupObjSelect[0].id;
                    this.groupObj.companyId = _groupObjSelect[0].company_id;
                    this.groupObj.branchId = _groupObjSelect[0].branch_id;
                    this.groupObj.branchCode = _groupObjSelect[0].branch_code;
                    this.groupObj.branchName = _groupObjSelect[0].branch_name;
                    this.groupObj.departmentId = _groupObjSelect[0].department_id;
                    this.groupObj.departmentCode = _groupObjSelect[0].department_code;
                    this.groupObj.departmentName = _groupObjSelect[0].department_name;
                    this.groupObj.groupCode = _groupObjSelect[0].code;
                    this.groupObj.groupName = _groupObjSelect[0].name;
                    this.groupObj.type = _groupObjSelect[0].type;
                }
            } else {
                this.groupObj = {
                    id: "",
                    companyId: "",
                    branchId: "",
                    branchCode: "",
                    branchName: "",
                    departmentId: "",
                    departmentCode: "",
                    departmentName: "",
                    groupCode: "",
                    groupName: "",
                    type: "",
                };

                if (_ids.length > 1) {
                    let _lists = this.lists;
                    let groupType = Constants.TypeAdminGroup;
                    let isGroup = true;

                    $.each(_ids, function (key, elm) {
                        let _groupObjSelect = _.filter(_lists, function (n) {
                            return n.id == elm;
                        });
                        if (!Utils.isEmptyArr(_groupObjSelect) && _groupObjSelect[0].type != groupType.group.id) {
                            isGroup = false;
                            return false;
                        }
                    });

                    if (isGroup == false) {
                        this.editObj.ids = [];
                    }
                }
            }

            /*
                let _ids = [];
                if (event.target.checked) {
                } else {
                }
                */

            return false;
        },

        selectAllGroup: function selectAllGroup (event) {
            event.preventDefault();
            let _ids = [];

            if (event.target.checked) {
                $.each(this.$refs.selectGroup, function (key, elm) {
                    elm.checked = true;
                    _ids.push(elm.value);
                });
            } else {
                $.each(this.$refs.selectGroup, function (key, elm) {
                    elm.checked = false;
                });
                _ids = [];
            }

            this.deleteObj.ids = _ids;
            this.editObj.ids = _ids;

            if (_ids.length == 1) {
                let id = _ids[0];
                // let _this = this;

                let _groupObjSelect = _.filter(this.lists, function (n) {
                    return n.id == id;
                });

                if (!Utils.isEmptyArr(_groupObjSelect)) {
                    this.groupObj.id = _groupObjSelect[0].id;
                    this.groupObj.companyId = _groupObjSelect[0].company_id;
                    this.groupObj.branchId = _groupObjSelect[0].branch_id;
                    this.groupObj.branchCode = _groupObjSelect[0].branch_code;
                    this.groupObj.branchName = _groupObjSelect[0].branch_name;
                    this.groupObj.departmentId = _groupObjSelect[0].department_id;
                    this.groupObj.departmentCode = _groupObjSelect[0].department_code;
                    this.groupObj.departmentName = _groupObjSelect[0].department_name;
                    this.groupObj.groupCode = _groupObjSelect[0].code;
                    this.groupObj.groupName = _groupObjSelect[0].name;
                    this.groupObj.type = _groupObjSelect[0].type;
                }
            } else {
                this.groupObj = {
                    id: "",
                    companyId: "",
                    branchId: "",
                    branchCode: "",
                    branchName: "",
                    departmentId: "",
                    departmentCode: "",
                    departmentName: "",
                    groupCode: "",
                    groupName: "",
                    type: "",
                };

                if (_ids.length > 1) {
                    let _lists = this.lists;
                    let groupType = Constants.TypeAdminGroup;
                    let isGroup = true;

                    $.each(_ids, function (key, elm) {
                        let _groupObjSelect = _.filter(_lists, function (n) {
                            return n.id == elm;
                        });
                        if (!Utils.isEmptyArr(_groupObjSelect) && _groupObjSelect[0].type != groupType.group.id) {
                            isGroup = false;
                            return false;
                        }
                    });

                    if (isGroup == false) {
                        this.editObj.ids = [];
                    }
                }
            }

            return false;
        },

        unSlectAllGroup: function unSlectAllGroup () {
            if (!Utils.isEmptyArr(this.$refs.selectGroup)) {
                $.each(this.$refs.selectGroup, function (key, elm) {
                    elm.checked = false;
                });
            }

            if (!Utils.isEmptyStr(this.$refs.selectAllGroup)) {
                this.$refs.selectAllGroup.checked = false;
            }

            this.deleteObj.ids = [];
            this.editObj.ids = [];

            this.groupObj = {
                branchId: "",
                branchCode: "",
                branchName: "",
                departmentId: "",
                departmentCode: "",
                departmentName: "",
                groupCode: "",
                groupName: "",
            };
        },

        resetData: function resetData () {
            this.loading = false;
            this.submitted = true;
            this.page = 1;
            this.lastPage = 0;
            this.lists = null;
            this.unSlectAllGroup();
        },

        getAllBranchs: function getAllBranchs () {
            GroupManagementService.getAllBranchs()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (!Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                                company_id: value.company_id,
                            };
                            _dataSelect.push(item);
                        });

                        this.branchSelectOptions = _dataSelect;
                        this.branchs = _dataSelect;
                    } else {
                        this.branchSelectOptions = [];
                        this.branchs = [];
                    }
                }).catch(error => {
                    this.branchSelectOptions = [];
                    this.branchs = [];
                });
            return false;
        },

        branchSelectChangeEvent (val) {
            if (Utils.isEmptyStr(val)) {
                this.departmentSelectOptions = this.departments;
                this.groupSelectOptions = this.groups;
                return false;
            }

            let _departmentRefer = _.filter(this.departments, function (n) {
                return n.branch_id == val;
            });
            let _groupRefer = _.filter(this.groups, function (n) {
                return n.branch_id == val;
            });
            this.departmentSelectOptions = _departmentRefer;
            this.groupSelectOptions = _groupRefer;
        },

        branchSelectEvent ({id, text}) {
        },

        getAllDepartments: function getAllDepartments () {
            GroupManagementService.getAllDepartments()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (!Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                                branch_id: value.branch_id,
                            };
                            _dataSelect.push(item);
                        });

                        this.departmentSelectOptions = _dataSelect;
                        this.departments = _dataSelect;
                    } else {
                        this.departmentSelectOptions = [];
                        this.departments = [];
                    }
                }).catch(error => {
                    this.departmentSelectOptions = [];
                    this.departments = [];
                });
            return false;
        },

        departmentSelectChangeEvent (val) {
            if (Utils.isEmptyStr(val)) {
                this.groupSelectOptions = this.groups;
                return false;
            }

            let _groupRefer = _.filter(this.groups, function (n) {
                return n.department_id == val;
            });
            this.groupSelectOptions = _groupRefer;
        },

        departmentSelectEvent ({id, text}) {
        },

        getAllGroups: function getAllGroups () {
            GroupManagementService.getAllGroups()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (!Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                                department_id: value.department_id,
                                branch_id: value.branch_id,
                            };
                            _dataSelect.push(item);
                        });

                        this.groupSelectOptions = _dataSelect;
                        this.groups = _dataSelect;
                    } else {
                        this.groupSelectOptions = [];
                        this.groups = [];
                    }
                }).catch(error => {
                    this.groupSelectOptions = [];
                    this.groups = [];
                });
            return false;
        },

        getAllCompanies: function getAllCompanies () {
            GroupManagementService.getAllCompanies()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (!Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                            };
                            _dataSelect.push(item);
                        });

                        this.companySelectOptions = _dataSelect;
                        this.companies = _dataSelect;
                    } else {
                        this.companySelectOptions = [];
                        this.companies = [];
                    }
                }).catch(error => {
                    this.companySelectOptions = [];
                    this.companies = [];
                });
            return false;
        },

        companySelectChangeEvent (val) {
            if (Utils.isEmptyStr(val)) {
                this.branchSelectOptions = this.branchs;
                this.departmentSelectOptions = this.departments;
                this.groupSelectOptions = this.groups;
                return false;
            }

            let _branchRefer = _.filter(this.branchs, function (n) {
                return n.company_id == val;
            });
            let _departmentRefer = _.filter(this.departments, function (n) {
                return _branchRefer.some(branch => branch.id === n.branch_id);
            });
            let _groupRefer = _.filter(this.groups, function (n) {
                return _branchRefer.some(branch => branch.id === n.branch_id);
            });
            this.branchSelectOptions = _branchRefer;
            this.departmentSelectOptions = _departmentRefer;
            this.groupSelectOptions = _groupRefer;
        },

        companySelectEvent ({id, text}) {
        },

        groupSelectChangeEvent (val) {
        },

        groupSelectEvent ({id, text}) {
        },

        requestPagination: function requestPagination (pageNum) {
            /*
                if(pageNum > 1) {
                    this.$router.push({path: '/admin/users', query: {page: pageNum}});
                } else {
                    this.$router.push({path: '/admin/users'});
                }
                */
            // this.page = pageNum;
            this.resetData();
            this.page = pageNum;
            this.fetchData();
            return false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/GroupManagement/List.vue